import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';
import { hasPermission } from '@apply/ui';
import { PermissionType } from '@apply/constants';

import UsersLandingPage from '../../../user/UsersLandingPage';
import AdminUserSummary from '../../../user/AdminUserSummary';
import PrincipalUsersSummary from '../../../user/PrincipalUsersSummary';
import BrokerUsersSummary from '../../../user/BrokerUsersSummary';
import { GeneralContractorUsersSummary } from '../../../user/GeneralContractorUsersSummary/GeneralContractorUsersSummary';
import AppraisalReviewersSummary from '../../../user/AppraisalReviewersSummary';

export default function UsersRoutes() {
    return (
        <>
            <Route
                path='/users'
                element={
                    <RequireAdmin>
                        <UsersLandingPage />
                    </RequireAdmin>
                }
            />
            {hasPermission(PermissionType.AdminUserView) && (
                <Route
                    path='/users/admins'
                    element={
                        <RequireAdmin>
                            <AdminUserSummary />
                        </RequireAdmin>
                    }
                />
            )}

            <Route
                path='/users/principals'
                element={
                    <RequireAdmin>
                        <PrincipalUsersSummary />
                    </RequireAdmin>
                }
            />
            <Route
                path='/users/brokers'
                element={
                    <RequireAdmin>
                        <BrokerUsersSummary />
                    </RequireAdmin>
                }
            />
            <Route
                path='/users/generalcontractors'
                element={
                    <RequireAdmin>
                        <GeneralContractorUsersSummary />
                    </RequireAdmin>
                }
            />
            <Route
                path='/users/reviewers'
                element={
                    <RequireAdmin>
                        <AppraisalReviewersSummary />
                    </RequireAdmin>
                }
            />
        </>
    );
}
